function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  /* space-y-4 -> 하위 요소 마진으로 대체 */\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n    border-color: var(--theme-primary, #3b82f6);\n    background-color: var(--theme-primary-faint, #eff6ff); /* bg-blue-50 dark:bg-blue-900/30 */\n    .dark &, body.dark &, body.vscode-dark & {\n      background-color: var(--theme-primary-dark-faint, rgba(59, 130, 246, 0.2));\n    }\n  "
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n    border-color: var(--theme-info-border, #93c5fd); /* border-blue-300 dark:border-blue-700 */\n    background-color: var(--theme-info-background-faint, #eff6ff); /* bg-blue-50 dark:bg-blue-900/20 */\n    .dark &, body.dark &, body.vscode-dark & {\n      border-color: var(--theme-info-border-dark, #3b82f6);\n      background-color: var(--theme-info-background-faint-dark, rgba(59, 130, 246, 0.15));\n    }\n  "
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n    border-color: var(--theme-success-border, #a7f3d0); /* border-green-300 dark:border-green-700 */\n    background-color: var(--theme-success-background-faint, #f0fdf4); /* bg-green-50 dark:bg-green-900/20 */\n    .dark &, body.dark &, body.vscode-dark & {\n      border-color: var(--theme-success-border-dark, #34d399);\n      background-color: var(--theme-success-background-faint-dark, rgba(16, 185, 129, 0.15));\n    }\n  "
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n    border-color: var(--theme-error-border, #fecaca); /* border-red-300 dark:border-red-700 */\n    background-color: var(--theme-error-background-faint, #fef2f2); /* bg-red-50 dark:bg-red-900/20 */\n    .dark &, body.dark &, body.vscode-dark & {\n      border-color: var(--theme-error-border-dark, #f87171);\n      background-color: var(--theme-error-background-faint-dark, rgba(239, 68, 68, 0.15));\n    }\n  "
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n      &:hover {\n        border-color: var(--theme-primary, #3b82f6); /* hover:border-blue-500 */\n      }\n    "
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  border: 2px dashed var(--theme-border, #d1d5db); /* 기본 테두리 */\n  border-radius: 0.5rem; /* rounded-lg */\n  padding: 1.5rem; /* p-6 */\n  transition: border-color 0.2s ease-in-out, background-color 0.2s ease-in-out;\n  background-color: var(--my-card-background, #f9fafb); /* 기본 배경 */\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: 0.5rem; /* space-y-2 */\n  /* pointer-events-none: 드롭 이벤트 처리를 위해 제거하거나 필요시 재적용 */\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  margin-bottom: 0.5rem; /* mb-2 */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 2.5rem; /* h-10 */\n  width: 2.5rem; /* w-10 */\n  border-radius: 9999px; /* rounded-full */\n  background-color: var(--theme-paper, #f3f4f6); /* 기본 배경 */\n\n  &.success {\n    background-color: var(--theme-success-background, #d1fae5); /* bg-green-100 dark:bg-green-900/30 */\n    .dark &, body.dark &, body.vscode-dark & { background-color: var(--theme-success-background-dark, rgba(16, 185, 129, 0.3)); }\n    svg { color: var(--theme-success, #059669); /* text-green-600 dark:text-green-400 */\n          .dark &, body.dark &, body.vscode-dark & { color: var(--theme-success-dark, #6ee7b7); }}\n  }\n  &.error {\n    background-color: var(--theme-error-background, #fee2e2); /* bg-red-100 dark:bg-red-900/30 */\n    .dark &, body.dark &, body.vscode-dark & { background-color: var(--theme-error-background-dark, rgba(220, 38, 38, 0.3)); }\n    svg { color: var(--theme-error, #dc2626); /* text-red-600 dark:text-red-400 */\n          .dark &, body.dark &, body.vscode-dark & { color: var(--theme-error-dark, #f87171); }}\n  }\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  height: 2.5rem; /* h-10 */\n  width: 2.5rem; /* w-10 */\n  color: var(--theme-icon-muted, #9ca3af); /* text-gray-400 dark:text-gray-500 */\n  margin-bottom: 0.5rem; /* mb-2 */\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        " /* Check, AlertCircle 공통 */\n  height: 1.5rem; /* h-6 */\n  width: 1.5rem; /* w-6 */\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  height: 2.5rem; /* h-10 */\n  width: 2.5rem; /* w-10 */\n  animation: spin 1s linear infinite;\n  color: var(--theme-primary, #3b82f6);\n\n  @keyframes spin {\n    from { transform: rotate(0deg); }\n    to { transform: rotate(360deg); }\n  }\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.875rem; /* text-sm */\n  font-weight: 500; /* font-medium */\n  color: var(--theme-text, inherit);\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.75rem; /* text-xs */\n  color: var(--theme-text-muted, #6b7280); /* text-gray-500 dark:text-gray-400 */\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        '\n  margin-top: 1rem; /* mt-4 */\n  width: 100%;\n  /* Button 컴포넌트의 variant="primary" 스타일 사용 */\n'
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  background-color: var(--theme-border-light, #e5e7eb); /* bg-gray-200 dark:bg-gray-700 */\n  border-radius: 9999px; /* rounded-full */\n  height: 0.5rem; /* h-2 */\n  margin-top: 1rem; /* mt-4 */\n  overflow: hidden; /* 내부 바 radius 처리 */\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  background-color: var(--theme-primary, #3b82f6); /* bg-blue-600 */\n  height: 100%; /* h-2 */\n  border-radius: 9999px; /* rounded-full */\n  transition: width 0.3s ease-in-out; /* transition-all duration-300 */\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
import React, { useEffect, useState } from 'react';
// Lucide React 직접 import - Vite 번들링 최적화 및 초기화 순서 문제 해결
import FolderUp from 'lucide-react/dist/esm/icons/folder-up';
import AlertCircle from 'lucide-react/dist/esm/icons/alert-circle';
import Check from 'lucide-react/dist/esm/icons/check';
import Loader2 from 'lucide-react/dist/esm/icons/loader-2';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Button } from "@edusense/shared-ui-kit";
import { DIRECTORY_UPLOAD_PROPS } from '@edusense/shared-project-upload-constants';
var UploaderWrapper = styled.div(_templateObject());
var DropZone = styled.div(_templateObject6(), function(param) {
    var isDragging = param.isDragging;
    return isDragging && css(_templateObject1());
}, function(param) {
    var isUploading = param.isUploading;
    return isUploading && css(_templateObject2());
}, function(param) {
    var isSuccess = param.isSuccess;
    return isSuccess && css(_templateObject3());
}, function(param) {
    var isError = param.isError;
    return isError && css(_templateObject4());
}, function(param) {
    var isDragging = param.isDragging, isUploading = param.isUploading, isSuccess = param.isSuccess, isError = param.isError;
    return !isDragging && !isUploading && !isSuccess && !isError && css(_templateObject5());
});
var DropZoneContent = styled.div(_templateObject7());
var StatusIconWrapper = styled.div(_templateObject8());
var DefaultIcon = styled(FolderUp)(_templateObject9());
var StatusIcon = styled.svg(_templateObject10());
var LoadingSpinner = styled(Loader2)(_templateObject11());
var Title = styled.h3(_templateObject12());
var Description = styled.p(_templateObject13());
var SelectButton = styled(Button)(_templateObject14());
var ProgressBarContainer = styled.div(_templateObject15());
var ProgressBar = styled.div(_templateObject16());
/**
 * 프로젝트 폴더 업로드 처리 컴포넌트
 * 
 * 🏗️ FSD Shared Layer - UI Folder Upload
 * 폴더의 드래그 앤 드롭 업로드 및 폴더 선택 기능을 제공합니다.
 */ var FolderUploader = function(param) {
    var uploadStatus = param.uploadStatus, uploadProgress = param.uploadProgress, uploadError = param.uploadError, onUpload = param.onUpload, onFolderChange = param.onFolderChange, folderInputRef = param.folderInputRef, onDropFolder = param.onDropFolder;
    var _useState = _sliced_to_array(useState(false), 2), isDragging = _useState[0], setIsDragging = _useState[1];
    var isUploading = uploadStatus === 'uploading';
    var isSuccess = uploadStatus === 'success';
    var isError = uploadStatus === 'error';
    useEffect(function() {
        var inputElement = folderInputRef === null || folderInputRef === void 0 ? void 0 : folderInputRef.current;
        if (!inputElement) {
            return;
        }
        Object.entries(DIRECTORY_UPLOAD_PROPS).forEach(function(param) {
            var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
            inputElement.setAttribute(key, value);
        });
    }, [
        folderInputRef
    ]);
    var handleUploadClick = function(e) {
        e.preventDefault();
        e.stopPropagation();
        setTimeout(function() {
            onUpload();
        }, 0);
    };
    var handleDragEnter = function(e) {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
    };
    var handleDragLeave = function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.currentTarget.contains(e.relatedTarget)) return;
        setIsDragging(false);
    };
    var handleDragOver = function(e) {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
    };
    var handleDrop = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(e) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        e.stopPropagation();
                        setIsDragging(false);
                        if (!(e.dataTransfer.items && e.dataTransfer.items.length > 0)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            onDropFolder(e.dataTransfer.items)
                        ];
                    case 1:
                        _state.sent();
                        e.dataTransfer.clearData();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDrop(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ React.createElement(UploaderWrapper, null, /*#__PURE__*/ React.createElement(DropZone, {
        isDragging: isDragging,
        isUploading: isUploading,
        isSuccess: isSuccess,
        isError: isError,
        onDragEnter: handleDragEnter,
        onDragLeave: handleDragLeave,
        onDragOver: handleDragOver,
        onDrop: handleDrop
    }, /*#__PURE__*/ React.createElement(DropZoneContent, null, isUploading ? /*#__PURE__*/ React.createElement(LoadingSpinner, null) : isSuccess ? /*#__PURE__*/ React.createElement(StatusIconWrapper, {
        className: "success"
    }, /*#__PURE__*/ React.createElement(StatusIcon, {
        as: Check
    })) : isError ? /*#__PURE__*/ React.createElement(StatusIconWrapper, {
        className: "error"
    }, /*#__PURE__*/ React.createElement(StatusIcon, {
        as: AlertCircle
    })) : /*#__PURE__*/ React.createElement(DefaultIcon, null), /*#__PURE__*/ React.createElement(Title, null, isDragging ? '여기에 폴더를 드롭하세요' : isUploading ? '폴더 업로드 중...' : isSuccess ? '폴더 업로드 완료' : isError ? '업로드 오류' : '프로젝트 폴더 업로드'), /*#__PURE__*/ React.createElement(Description, null, isUploading ? "".concat(uploadProgress, "% 완료") : isSuccess ? '모든 파일이 성공적으로 업로드되었습니다.' : isError ? uploadError || '오류가 발생했습니다. 다시 시도해주세요.' : 'package.json을 포함한 프로젝트 폴더를 드롭하거나 선택하세요.')), !isUploading && !isSuccess && !isDragging && /*#__PURE__*/ React.createElement(SelectButton, {
        type: "button",
        onClick: handleUploadClick,
        variant: "primary"
    }, "폴더 선택"), isUploading && /*#__PURE__*/ React.createElement(ProgressBarContainer, null, /*#__PURE__*/ React.createElement(ProgressBar, {
        style: {
            width: "".concat(uploadProgress, "%")
        }
    })), /*#__PURE__*/ React.createElement("input", {
        type: "file",
        multiple: true,
        style: {
            display: 'none'
        },
        ref: folderInputRef,
        onChange: onFolderChange
    })));
};
export default FolderUploader;
